module.exports = __webpack_public_path__ + "static/pic03-85231680e3df100b6561dde51af0f237.jpg";